import { Injectable } from '@angular/core';
import { SdkInitText } from '../../model/user/sdk-init-text';

@Injectable({
  providedIn: 'root'
})
export class TextService {
  constructor() {
  }

  keyValueMapping(key: string, replacementValue: string,sdkInitTexts: Array<SdkInitText>): string {
    let value = null;
    let sdk = sdkInitTexts.find(a => a.name === key);
    if (sdk != null) {
      value = sdk.value;
    } else {
      value = replacementValue;
    }
    return value;
  }
}
